import { render, staticRenderFns } from "./SendPermitInvitation.vue?vue&type=template&id=8c02b17e"
import script from "./SendPermitInvitation.vue?vue&type=script&lang=js"
export * from "./SendPermitInvitation.vue?vue&type=script&lang=js"
import style0 from "./SendPermitInvitation.vue?vue&type=style&index=0&id=8c02b17e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports